// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warningIcon[data-v-5dcc30da] {\n  font-size: 14px;\n  margin-left: 10px;\n  color: red;\n}\n[data-v-5dcc30da] .el-form-item--mini.el-form-item,\n.el-form-item--small.el-form-item[data-v-5dcc30da] {\n  margin-bottom: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
